import React, {Component} from 'react';
import { faTimes, faArrowCircleLeft } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

class PopupEquipment extends Component {

  turnLeft = () => {
    this.props.turnEquipment('left');
  }
  turnRight = () => {
    this.props.turnEquipment('right');
  }

  render() {

    const {
      position, equipment
      , onClose, cloneEquipment, deleteEquipment, moveEquipmentByDir,
    } = this.props;


    const moveDirs = ['up', 'right', 'down', 'left'];

    return (
      <div className="Constructor-Playground-Popup" style={position}>
        <div className="item-title">{equipment.name}</div>
        <FontAwesomeIcon className="Constructor-Playground-Popup-Close" icon={faTimes} onClick={onClose}/>
        <div>

          <div className="Constructor-Playground-Popup-Controls">
          {/*btn turnLeft*/}
          <span onClick={this.turnLeft}
                className="Constructor-Playground-Popup-Icon_turn Constructor-Playground-Popup-Icon_turn_left"
          />
          {/*btns move */}
          <div className="Constructor-Playground-Popup-Icon_arrows">
            <div className="Constructor-Playground-Popup-Icon_arrows_center"></div>
            {moveDirs && moveDirs.map(dir => (
              <FontAwesomeIcon icon={faArrowCircleLeft}
                onClick={() => moveEquipmentByDir(dir)}
                key={`move_btn_${dir}`}
                className={`Constructor-Playground-Popup-Icon_arrow Constructor-Playground-Popup-Icon_arrow_${dir}`}
              />
            ))}
          </div>

          {/*btn turnRight*/}
          <span
            onClick={this.turnRight}
            className="Constructor-Playground-Popup-Icon_turn Constructor-Playground-Popup-Icon_turn_right"
          />

          <span onClick={cloneEquipment} className="Constructor-Playground-Popup-Icon Constructor-Playground-Popup-Icon_clone"/>

          <span onClick={deleteEquipment} className="Constructor-Playground-Popup-Icon Constructor-Playground-Popup-Icon_delete"/>
          </div>

        </div>

      </div>
    );
  }
}

export default PopupEquipment;
